import './about.scss';
require('../../assets/images/flares.svg');
